import styles from './Table.module.css';

export const Table = ({ children }) => <table className={styles.table}>{children}</table>;

export const TableRow = ({ children }) => <tr className={styles.row}>{children}</tr>;

export const TableHead = ({ children }) => (
  <thead className={styles.head}>{children}</thead>
);

export const TableBody = ({ children }) => (
  <tbody className={styles.body}>{children}</tbody>
);

export const TableHeadCell = ({ children, style, align, ...rest }) => (
  <th
    className={styles.headCell}
    style={align ? { ...style, textAlign: align } : style}
    {...rest}
  >
    {children}
  </th>
);

export const TableCell = ({ children, style, align, ...rest }) => (
  <td
    className={styles.cell}
    style={align ? { ...style, textAlign: align } : style}
    {...rest}
  >
    {children}
  </td>
);
